import type {BaseInputProps} from '@cohort/merchants/components/form/input/BaseInput';
import BaseInput from '@cohort/merchants/components/form/input/BaseInput';
import type {FormField} from '@cohort/merchants/lib/form/utils';
import {updateLocalizedString} from '@cohort/merchants/lib/Utils';
import type {Language} from '@cohort/shared/schema/common';
import get from 'lodash/get';
import type {FieldValues} from 'react-hook-form';
import {useController} from 'react-hook-form';

type LocalizedInputProps<T extends FieldValues> = BaseInputProps &
  FormField<T> & {
    selectedLanguage: Language;
  };

export default function LocalizedInput<T extends FieldValues>({
  register,
  control,
  rules,
  selectedLanguage,
  ...props
}: LocalizedInputProps<T>): JSX.Element {
  const {field, fieldState} = useController({
    control,
    name: props.name,
  });

  const errorMessage =
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    get(fieldState, `error.${selectedLanguage}.message`) ?? get(fieldState, `error.message`);

  return (
    <BaseInput
      insetPrefix="https://"
      type="text"
      error={errorMessage}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
        if (!value.startsWith('https://')) {
          value = 'https://' + value;
        }
        field.onChange(updateLocalizedString(selectedLanguage, field.value, value));
      }}
      value={field.value?.[selectedLanguage]?.replace('https://', '') ?? ''}
      {...props}
      ref={field.ref}
    />
  );
}
